import * as importedWasm from "../pkg/bab_rs_wasm_bg.wasm";
import * as imports from "../pkg/bab_rs_wasm_bg.js";

let wasm = importedWasm;
if (typeof process !== "undefined" && process.versions.bun) {
    const wasmPath = `${__dirname}/../pkg/bab_rs_wasm_bg.wasm`;
    const wasmBytes = require('fs').readFileSync(wasmPath);
    const wasmModule = new WebAssembly.Module(wasmBytes);
    const imports0 = {
        __proto__: null,
        ...(Object.fromEntries(Object.entries(imports).filter(entry => entry[0].startsWith("__wb") && typeof entry[1] === "function"))),
    };
    let wasmInstance = new WebAssembly.Instance(wasmModule, {
        __proto__: null,
        "./bab_rs_wasm_bg.js": imports0,
    });
    wasm = wasmInstance.exports;
}

imports.__wbg_set_wasm(wasm);
wasm.__wbindgen_start();
export {
    william3_hash
} from "../pkg/bab_rs_wasm_bg.js";
